// Modules whose sidebar/route visibility requires superadmin or global-approver status,
// regardless of whether the role's Permission row for that resource is granted. These
// permissions still need to stay grantable — e.g. the Sample Design form reads Company
// and Employee data for its dropdowns — but a normal employee shouldn't see the full
// Employee/Company/etc. management pages just because their role happens to carry read
// access to the underlying data for that dropdown.
export const RESTRICTED_TO_SUPERADMIN_OR_GLOBAL_APPROVER = new Set([
  'employee', 'department', 'role', 'company', 'employee_location', 'password_reset_questions',
]);

export function isSuperadminOrGlobalApprover() {
  try {
    const e = JSON.parse(localStorage.getItem('employee') || '{}');
    return e.role_level === 'level_0' || e.is_global_approver === true || e.is_global_approver === 1;
  } catch { return false; }
}

// Applies the override on top of a resource's raw permission-based read access: for the
// restricted resources above, visibility requires superadmin/global-approver outright
// (the Permission grant no longer matters for seeing the module); every other resource
// is unaffected.
export function visibleFor(resource, canRead) {
  if (RESTRICTED_TO_SUPERADMIN_OR_GLOBAL_APPROVER.has(resource)) {
    return isSuperadminOrGlobalApprover();
  }
  return canRead;
}
